export { SimpleEventSponsorsAside } from './SimpleEventSponsorsAside';
